document.documentElement.classList.remove('no-js');

(() => {
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem('eightEyeWishlist') || '[]'); } catch (error) { saved = []; }
  const wishlist = new Set(saved.map(String));
  let toastTimer;

  const toast = (message) => {
    let element = document.querySelector('[data-global-product-toast]');
    if (!element) {
      element = document.createElement('div');
      element.className = 'global-product-toast';
      element.dataset.globalProductToast = '';
      document.body.appendChild(element);
    }
    element.textContent = message;
    element.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => element.classList.remove('is-visible'), 2600);
  };

  const refreshWishlistButtons = () => {
    document.querySelectorAll('[data-global-wishlist]').forEach((button) => {
      const id = String(button.closest('[data-global-product-card]')?.dataset.productId || '');
      const isSaved = wishlist.has(id);
      button.classList.toggle('is-saved', isSaved);
      button.textContent = isSaved ? '♥ 已加入 Wish List' : '♡ 加入 Wish List';
    });
  };

  document.addEventListener('click', async (event) => {
    const wishlistButton = event.target.closest('[data-global-wishlist]');
    if (wishlistButton) {
      const id = String(wishlistButton.closest('[data-global-product-card]')?.dataset.productId || '');
      if (!id) return;
      wishlist.has(id) ? wishlist.delete(id) : wishlist.add(id);
      localStorage.setItem('eightEyeWishlist', JSON.stringify([...wishlist]));
      refreshWishlistButtons();
      toast(wishlist.has(id) ? '多謝，如有再販會盡快通知（只限會員）' : '已從 Wish List 移除');
      return;
    }

    const addButton = event.target.closest('[data-global-add-cart]');
    if (addButton) {
      const card = addButton.closest('[data-global-product-card]');
      const variantId = Number(card?.dataset.variantId || 0);
      if (!variantId) return;
      addButton.disabled = true;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
        if (!response.ok) throw new Error('cart');
        toast('已加入購物車');
      } catch (error) {
        toast('未能加入購物車，請稍後再試');
      } finally {
        addButton.disabled = false;
      }
      return;
    }

    const zoomButton = event.target.closest('[data-global-zoom]');
    if (zoomButton) {
      let dialog = document.querySelector('[data-global-product-zoom]');
      if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.className = 'global-product-zoom';
        dialog.dataset.globalProductZoom = '';
        dialog.innerHTML = '<button type="button" aria-label="關閉">×</button><img>';
        dialog.querySelector('button').addEventListener('click', () => dialog.close());
        document.body.appendChild(dialog);
      }
      const image = dialog.querySelector('img');
      image.src = zoomButton.dataset.image;
      image.alt = zoomButton.dataset.alt || '';
      dialog.showModal();
    }
  });

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', refreshWishlistButtons) : refreshWishlistButtons();
})();
